export default function NextArrow() {
  return (
    <>
      <svg
        className={'md:hidden'}
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="37"
        viewBox="0 0 19 37"
        fill="none"
      >
        <title>Next chapter</title>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.292 17.767L6.80655 9.28154L4.68555 11.4025L12.1105 18.8275L4.68555 26.2525L6.80655 28.3735L15.292 19.888C15.5733 19.6067 15.7312 19.2253 15.7312 18.8275C15.7312 18.4298 15.5733 18.0483 15.292 17.767Z"
          fill="#C7C7C7"
        />
      </svg>
      <svg
        className={'hidden md:block'}
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="41"
        viewBox="0 0 21 41"
        fill="none"
      >
        <title>Next chapter</title>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.1004 19.6486L7.67209 10.2203L5.31543 12.5769L13.5654 20.8269L5.31543 29.0769L7.6721 31.4336L17.1004 22.0053C17.4129 21.6927 17.5884 21.2689 17.5884 20.8269C17.5884 20.385 17.4129 19.9611 17.1004 19.6486Z"
          fill="#C7C7C7"
        />
      </svg>
    </>
  )
}
